import React from "react";
import ContactForm from "./ContactForm";

const Contact = ({ lenguaje }) => {
  return (
    <section className="contact-outer-wrapper">
      <div className="contact-component">
        <div className="contactinfo">
          <div>
            <h2>
              {lenguaje == "eng" ? "Contact Info" : "Información de Contacto"}
            </h2>
            <ul className="info">
              <li>
                <span>
                  <i class="icon fas fa-location-arrow"></i>
                </span>
                <span>Temuco, Chile</span>
              </li>
              <li>
                <span>
                  <i class="icon fas fa-envelope"></i>
                </span>
                <span>tomas.sarmientoc@gmail.com</span>
              </li>
              <li>
                <span>
                  <i class="icon fas fa-mobile-alt"></i>
                </span>
                <span>+56921912842</span>
              </li>
            </ul>
          </div>
          <ul className="sci">
            <li>
              <a href='https://www.linkedin.com/in/tomas-sarmientoc/'>
                <i class="icon fab fa-linkedin"></i>
              </a>
            </li>
          </ul>
        </div>
        <div className="contactform">
          <div className="formBox">
            <ContactForm lenguaje={lenguaje} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
